export class MessageLocationBody {
  latitude: number;
  longitude: number;
  address: string;
  comment_parent_id: string;
  is_encrypted: number;
  acknowledgement?: any;
}